export default "__VITE_ASSET__DClGweDI__"